<template>
  <div class="application">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <div class="btns">
      <div>
        <el-button
          type="primary"
          size="small"
          class="addCount"
          @click="addCount"
        >
          新建
        </el-button>
        <el-button
          plain
          size="small"
          class="importAccount"
          @click="importAccount"
        >
          导入
        </el-button>
      </div>
      <div class="searchBox">
        <el-input
          v-model="searchValue"
          placeholder="支持搜索账户名/邮箱"
          @keyup.enter.native="searchAccountList"
        ></el-input>
        <span class="iconBox" @click="searchAccountList">
          <i class="icon icon-search"></i>
        </span>
      </div>
    </div>

    <el-table :data="tableData" tooltip-effect="light" style="width: 100%">
      <el-table-column
        label="账户名"
        prop="accountName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="姓名"
        prop="userName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="电子邮箱"
        prop="email"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="手机号码"
        prop="telephone"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="enable"
        label="启用状态"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.enable"
            @input="enableChange(scope.row.enable, scope.row.id, scope.row.fromFed)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="账号来源"
        prop="fedName"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px"
        align="center"
        class-name="options"
      >
        <template slot-scope="scope">
          <span class="textBtn" @click="handleDetail(scope.row.id)">
            详情
          </span>
          <span class="textBtn" @click="handleReset(scope.row.id,scope.row.fromFed)">
            重置密码
          </span>
          <span
            class="textBtn delete"
            @click="handleDelete(scope.row.id, scope.row.fromFed)"
            v-if="scope.row.accountName !== 'admin'"
          >
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total"
      :current-page.sync="pageNum"
      @current-change="pageChange"
    >
    </el-pagination>
    <el-dialog
      title="重置密码"
      width="600px"
      :visible.sync="dialogPasswordVisible"
    >
      <el-form
        :model="ruleFormPassword"
        :rules="rulesPassword"
        ref="ruleFormPassword"
        label-width="100px"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            name="newPassword"
            type="password"
            v-model="ruleFormPassword.newPassword"
            placeholder="至少8位，需包含大小写字母和数字"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="sureNewPassword">
          <el-input
            name="sureNewPassword"
            type="password"
            v-model="ruleFormPassword.sureNewPassword"
            placeholder="确认新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPasswordForm">确 定</el-button>
        <el-button @click="dialogPasswordVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="tipTitle"
      width="500px"
      :visible.sync="dialogRemoveOrAnable"
    >
      <div class="deleteText">
        {{ tipText }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemoveOrAnable"
          >确 定</el-button
        >
        <el-button @click="dialogRemoveOrAnable = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/userManage.js"
// import Base16 from '@/common/base16.js'
// import { timeFormat } from '@/common/utils.js'
import { createNamespacedHelpers } from "vuex"
const { mapState, mapMutations } = createNamespacedHelpers("userManage")

// import {
//   getStore
// } from '@/common/utils.js'
export default {
  data() {
    // 检验新密码
    const checkFormNewPassword = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      let pattern = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/g
      if (value === "") {
        callback(new Error("请输入新密码"))
      } else if (!pattern.test(value)) {
        callback(new Error("至少8位，需包含大小写字母和数字"))
      } else {
        callback()
      }
    }
    // 检验确认密码
    const checkFormSurePassword = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (value === "") {
        callback(new Error("请输入确认密码"))
      } else if (value !== this.ruleFormPassword.newPassword) {
        callback(new Error("密码输入不一致"))
      } else {
        callback()
      }
    }
    return {
      moduleTitle: "账户管理",
      dialogRemoveOrAnable: false,
      dialogPasswordVisible: false,
      currentFlag: "delete",
      tableData: [],
      enterpriseId: "",
      breadcrumb: [
        {
          label: "账户管理"
        }
      ],
      ruleFormPassword: {
        newPassword: "",
        sureNewPassword: ""
      },
      rulesPassword: {
        newPassword: [
          { required: true, validator: checkFormNewPassword, trigger: "blur" }
        ],
        sureNewPassword: [
          { required: true, validator: checkFormSurePassword, trigger: "blur" }
        ]
      },
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentAccountId: ""
      // searchValue: ""
    }
  },
  computed: {
    tipText() {
      return this.currentFlag === "delete"
        ? "确认删除这个账户吗？"
        : this.currentFlag === "enable"
        ? "确认启用这个账户吗？"
        : "确认禁用这个账户吗？"
    },
    tipTitle() {
      return this.currentFlag === "delete"
        ? "删除提示"
        : this.currentFlag === "enable"
        ? "启用提示"
        : "禁用提示"
    },
    searchValue: {
      get() {
        return this.keyword
      },
      set(value) {
        this.UPDATE_KEYWORD(value)
      }
    },
    ...mapState(["keyword"])
  },
  mounted() {
    this.getUsersList()
  },
  methods: {
    ...mapMutations(["UPDATE_KEYWORD"]),
    // 查询账户列表
    async getUsersList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        key: this.searchValue
      }
      let { status, data } = await APIS.getRealmsUsers(this.realmName, {
        params
      })
      if (status === 0) {
        this.total = data.totalCount || 0
        if (data && data.list) {
          this.tableData = data.list.map((item, index) => {
            return {
              index: index,
              accountName: item.accountname,
              userName: item.username,
              email: item.email,
              telephone: item.telephone,
              enable: item.enabled,
              fedName: item.fedName,
              id: item.id,
              fromFed: item.fromFed
            }
          })
        }
      }
    },
    // 重置密码
    async resetPassword() {
      let params = {
        type: "password",
        value: this.ruleFormPassword.newPassword,
        temporary: false
      }
      let { status } = await APIS.putResetPassword(
        this.realmName,
        this.currentAccountId,
        { data: params }
      )
      if (status === 0) {
        this.dialogPasswordVisible = false
      }
    },
    // 删除账户
    async deleteUser() {
      let { status } = await APIS.deleteRealmsUserById(
        this.realmName,
        this.currentAccountId
      )
      this.dialogRemoveOrAnable = false
      if (status === 0) {
        if (this.total === 1) {
          this.pageNum = 1
        } else if ((this.total - 1) % this.pageSize === 0) {
          this.pageNum -= 1
        }
        this.getUsersList()
      }
    },
    // 更新账户的启用、禁用状态
    async updateAccountInfor() {
      let currentAccount = this.tableData.find(
        item => item.id === this.currentAccountId
      )
      if (currentAccount && currentAccount.enable !== undefined) {
        let params = {
          enabled: !currentAccount.enable
        }
        let { status } = await APIS._putRealmsUserById(
          this.realmName,
          this.currentAccountId,
          { data: params }
        )
        this.dialogRemoveOrAnable = false
        if (status === 0) {
          currentAccount.enable = !currentAccount.enable
        }
      }
    },
    // 关键词搜索
    searchAccountList() {
      this.pageNum = 1
      this.getUsersList()
    },
    // 翻页
    pageChange() {
      this.getUsersList()
    },
    // 初始化重置密码表单
    initPasswordForm() {
      this.$refs["ruleFormPassword"].resetFields()
      this.ruleFormPassword.newPassword = ""
      this.ruleFormPassword.sureNewPassword = ""
    },
    // 添加账户
    addCount() {
      this.$router.push("/userManage/addCount")
    },
    // 导入账户
    importAccount() {
      this.$router.push("/userManage/importAccount")
    },
    handleDetail(id) {
      this.$router.push({
        path: "/userManage/detailCount",
        query: {
          accountId: id
        }
      })
    },
    // 打开重置密码弹窗
    handleReset(id,fromFed) {
      if(fromFed) {
        // this.$message.error({
        //   message: '重置失败，用户联合账户暂不支持在IDaaS管理平台重置密码'
        // })
        // return
      }
      this.currentAccountId = id
      this.dialogPasswordVisible = true
      this.$nextTick(() => {
        this.initPasswordForm()
      })
    },
    // 打开删除账户弹窗
    handleDelete(id, fromFed) {
      if(fromFed) {
        // this.$message.error({
        //   message: '删除失败，用户联合账户暂不支持在IDaaS管理平台删除'
        // })
        // return
      }
      this.currentFlag = "delete"
      this.currentAccountId = id
      this.dialogRemoveOrAnable = true
    },
    // 启用状态改变，打开提示确认弹窗
    enableChange(enable, id, fromFed) {
      if(fromFed) {
        // this.$message.error({
        //   message: '启用状态修改失败，用户联合账户暂不支持在IDaaS管理平台修改启用状态'
        // })
        // return
      }
      this.currentFlag = !enable ? "enable" : ""
      this.dialogRemoveOrAnable = true
      this.currentAccountId = id
    },
    // 提交删除、启用、禁用状态
    submitRemoveOrAnable() {
      if (this.currentFlag === "delete") {
        this.deleteUser()
      } else {
        this.updateAccountInfor()
      }
    },
    // 提交重置密码表单
    submitPasswordForm() {
      this.$refs["ruleFormPassword"].validate(valid => {
        if (valid) {
          this.resetPassword()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.application {
  .name {
    display: none; //暂时隐藏
  }
  .btns {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .searchBox {
      display: inline-flex;
      .iconBox {
        width: 30px;
        background-color: rgba(22, 155, 213, 1);
        flex-shrink: 0;
        text-align: center;
        line-height: 26px;
        cursor: pointer;
      }
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
